import React from "react";
import PatientFormModal from "./PatientFormModal";

interface NewPatientModalProps {
  isOpen: boolean;
  onClose: () => void;
  onPatientCreated?: (patient: any) => void;
  context?: string;
  title?: string;
  description?: string;
}

export default function NewPatientModal({
  isOpen,
  onClose,
  onPatientCreated,
  title = "Patient Registration",
}: NewPatientModalProps) {
  const handleSuccess = (patient: any, intent: 'patient-only' | 'patient-and-rx') => {
    onPatientCreated?.(patient);
    // Note: intent is handled by the parent PatientFormModal
  };

  return (
    <PatientFormModal
      isOpen={isOpen}
      onClose={onClose}
      onSuccess={handleSuccess}
      mode="create"
      compact={true}
      title={title}
      showPrescriptionOption={true}
    />
  );
}
